import type {
  FormSelectLocalControl,
  KycPepType,
  KycPepControlType,
} from 'src/types/form-config';
import { getFormDataLimit } from '../../../utils';

import { KycProps } from '../../../constants/kyc';

const workGov: FormSelectLocalControl = {
  tag: 'select',
  placeholder: 'government employee',
  name: KycProps.WORK_GOV,
  type: 'text',
  label: 'Have you work in a government agency or institution?',
  options: [
    { value: false, display: 'No' },
    { value: true, display: 'Yes' },
  ],
  validator: 'required=true',
};

const govRelative: FormSelectLocalControl = {
  tag: 'select',
  placeholder: 'government relative',
  name: KycProps.GOV_RELATIVE,
  type: 'text',
  label:
    'Do you have any relative who is/was an elected government official or who is/was an appointed government official?',
  options: [
    { value: false, display: 'No' },
    { value: true, display: 'Yes' },
  ],
  validator: 'required=true',
};

const controls: KycPepControlType = [workGov, govRelative];

const KycPepData: KycPepType = {
  name: 'pep',
  display: 'PEP',
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycPepData;
